/* eslint-disable  */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import axios from "axios";
import * as queryService from "./queryService";
import Multiselect from "@vueform/multiselect";
import moment from "moment";
import store from '@/store';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { Result } from "vite/node_modules/postcss";
import alertdetails from "../viewAlertDetails/viewAlertDetails.vue"
import NestedJsonTable from "../../custom_lib/nestedjsontotable.vue";
import customModal from "../customModal/customModal.vue";
export default {
    name: 'querymapping',
    components: { Multiselect, alertdetails, NestedJsonTable, customModal },
    props: {

        queryid: String,
        closedoption: {
            type: String,
            default: 'allQueryList'
        },
    },
    data() {
        return {
            fhirStudyRef: "",
            fhirdataarray: null,
            roleprivileges: "",
            baseurl: process.env.VUE_APP_Service_URL,
            messages: [],
            queries: {},
            response: [],
            replies: [],
            lastMessage: [],
            fhirdata: null,
            postReply: "",
            raisedBy: "",
            queryId: "",
            removeButtons: false,
            saveRemove: false,
            showForm: false,
            saveShowForm: false,
            lastModifier: "",
            lastModifiedDate: "",
            length: 0,
            values: {
                mode: 'tags',
                value: [],
                options: [],
                closeOnSelect: false,
                searchable: true,
                createTag: true,
                resolveOnLoad: true
            },
            recipients: [],
            userName: "",
            showList: false,
            studyName: "",
            sites: "",
            defaultTime: "",
            showQueryClosurePopup: false,
            reopenqueryPopup:false,
            queryCloseReasons: [],
            reopenQueryReasons: [],
            selectedReasonId: '',
            reasonselect: false,
            selectedReopenReasonId: '',
            additionalComments: '',
            validationError: false,
            closureAction: '',
            isExporting: false
        }
    },
    async mounted() {
        this.fhirStudyRef = localStorage.getItem("fhirviewstudyref");
        console.log("this.fhirStudyRef", this.fhirStudyRef);
        window.addEventListener("studyIdChanged", async (event) => {
            console.log("StudyIDChanged into" + event.detail.storage);
            // window.location.reload();
            this.queryId = this.queryid
            await this.getUserName();
            await this.getbyId();
            await this.getStudyById();
            await this.getMessage();
            await this.getSites();
            await this.getRecipients();
        });
        this.defaultTime = localStorage.getItem("timeformat");
        await this.setroleprivileges();
        this.queryId = this.queryid
        await this.getUserName();
        await this.getbyId();
        await this.getRecipients();
        await this.getQueryCloseReasons();
        await this.getReopenQueryReasons();
    },
    computed: {
        hasQueryData() {
            return !!(this.queries && (this.queries.id || this.queries.queryId));
        },
        isDisabled() {
            if (this.postReply == "") {
                return true
            }
        }
    },
    methods: {
        async setroleprivileges() {
            this.roleprivileges = await store.getters.getRolesprivilegeData;
        },
        async gotoform() {
            store.dispatch("setFieldName", this.queries.fieldName);
            console.log("Pat id in query:", this.queries.patientId);
            localStorage.setItem("patientIdis", this.queries.patientId)

            //this.$router.push(`/showform/forms/${this.queries.formId}`);
            const archive = false;
            this.$router.push(`/showform/forms/${this.queries.formId}/${archive}`);
        },
        async exportpdf() {
            await this.getStudyById();
            console.log("", this.studyName);
            console.log("export",);
            let pdffilename = "";
            if (this.queries.formId == "" || this.queries.formId == '' || this.queries.formId == null) {
                // general Query
                //:'Study'_QueryID'.pdf
                pdffilename = this.studyName + "_" + this.queries.queryId;
            }
            else {
                // field, page or form Query
                //'Study'_'Site code'_'Subject ID_'Query ID'.pdf
                pdffilename = this.studyName + "_" + this.queries.siteId + "_" + this.queries.subjectId + "_" + this.queries.queryId;
            }
            console.log("for pdf", pdffilename);

            // Hide buttons/icons before capturing, and make sure the browser
            // has actually painted the hidden state before html2canvas runs
            this.isExporting = true;
            await this.$nextTick();
            await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));

            try {
                let element = document.getElementById('printcontent');
                let endMarker = document.getElementById('PrintContent_end');

                if (!element) {
                    console.error('printcontent element not found');
                    return;
                }

                // Default to full height if the end marker isn't present for some reason
                let captureHeight = element.scrollHeight;

                if (endMarker) {
                    const containerRect = element.getBoundingClientRect();
                    const markerRect = endMarker.getBoundingClientRect();
                    // Distance from the top of #printcontent to the bottom of #PrintContent_end
                    captureHeight = Math.ceil(markerRect.bottom - containerRect.top);
                } else {
                    console.warn('PrintContent_end marker not found, capturing full printcontent height');
                }

                let doc = new jsPDF('p', 'mm');
                console.log("element is", element, "captureHeight is", captureHeight);

                await html2canvas(element, {
                    height: captureHeight,
                    windowHeight: captureHeight
                }).then(canvas => {
                    console.log("for pdf2");
                    let imgData = canvas.toDataURL('image/png');

                    let imgWidth = 210;
                    let pageHeight = 295;
                    let imgHeight = canvas.height * imgWidth / canvas.width;
                    let heightLeft = imgHeight;
                    let position = 10;
                    doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                    heightLeft -= pageHeight;
                    while (heightLeft >= 0) {
                        position = (heightLeft - imgHeight) + 10;
                        doc.addPage();
                        doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                        heightLeft -= pageHeight;
                    }
                    //test pdf save ends
                });
                doc.save(pdffilename + '.pdf');
            } finally {
                // Always restore visibility, even if capture throws
                this.isExporting = false;
            }
        },
        filter(date) {
            if (date) {
                return moment(date).format('DD-MM-YYYY')
            }
            console.log("Reverse is")
            console.log(date)

        },
        formatTime(time) {
            if (time) {
                return moment(time).format(this.defaultTime);
            }

        },
        async getSites() {
            const currentstudy = await store.getters.getStudyIs;
            const idtoken = store.getters.getIdToken;
            await axios
                .get(`${this.baseurl}/management/site/searchlist?SiteCode=` + this.queries.siteId + `&StudyID=` + currentstudy,
                    {
                        headers: {
                            Authorization: "Bearer " + idtoken,
                            "Content-Type": "application/json",
                        }
                    })
                .then((res) => {
                    this.sites = res.data.results[0];
                    console.log("siteslist");
                    console.log(this.sites.results[0]);

                })
                .catch((err) => {
                    console.log(err);
                });
        },
        async getRecipients() {
            if (this.queries.queryFor == "General Query") {
                const valnow = await store.getters.getStudyIs;
                const idtoken = store.getters.getIdToken;
                await axios
                    // .get(`${this.baseurl}/account-core/user/getusersbysiteprivilege?studyid=${valnow}&siteCode=${this.queries.siteId}`,
                    .get(`${this.baseurl}/management/study/getusersinstudy?StudyId=${valnow}`,
                        {
                            headers: {
                                Authorization: "Bearer " + idtoken,
                                "Content-Type": "application/json",
                            }
                        })
                    .then((res) => {
                        console.log("Recipients are...", res.data);
                        this.values.options = [];
                        res.data.forEach(element => {
                            if (element.email != this.userName) { this.values.options.push(element) }
                        });

                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
            else {
                await this.getSites();
                console.log("hiii", this.sites.siteID);
                const valnow = await store.getters.getStudyIs;
                const idtoken = store.getters.getIdToken;
                console.log("Reccccc", this.queries);
                await axios
                    .get(`${this.baseurl}/account-core/user/getusersbysiteprivilege?studyid=${valnow}&siteCode=${this.queries.siteId}`,
                        //.get(`${this.baseurl}/management/study/getusersinstudy?StudyId=${valnow}`,
                        {
                            headers: {
                                Authorization: "Bearer " + idtoken,
                                "Content-Type": "application/json",
                            }
                        })
                    .then((res) => {
                        console.log("in service function");
                        console.log("Recipients are...", res.data);
                        this.values.options = [];
                        res.data.forEach(element => {
                            if (element.email != this.userName) { this.values.options.push(element) }
                        });

                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        },
        // replay and colse
        async replyClose(removeButtons, showForm) {
            if (this.values.value.includes(this.userName)) {
                const filtersList = this.values.value.filter(element => element !== this.userName)
                this.values.value = filtersList
            }
            if (this.values.value.length == 0) {
                alert(this.$t('navigations.please select a recipient'))
            }
            else {

                var replyClose = confirm(this.$t('navigations.are you sure you want to send this message and close this query?'));
                if (replyClose == true) {
                    this.raisedBy = this.userName
                    await queryService.apiReply(this.baseurl, this.queries.id, this.postReply, this.raisedBy, this.values.value, this.userName, this.recipients)
                    await queryService.apiClose(this.baseurl, this.userName, this.queries.id)
                    removeButtons = !removeButtons
                    showForm = !showForm
                    if (this.closedoption == "showform") {
                        await this.$router.go(-1);
                    }
                    else {
                        await this.$router.push(`/${this.closedoption}`);
                    }
                }
            }
        },
        async getStudyById() {
            const valnow = await store.getters.getStudyIs;
            const idtoken = store.getters.getIdToken;
            await axios.get(`${this.baseurl}/management/study/getbyid?id=${valnow}`,
                {
                    headers: {
                        Authorization: "Bearer " + idtoken,
                    },
                })
                .then(res => {
                    this.studyName = res.data.studyName;
                })
        },
        //Get by Id         
        async getbyId() {
            const idtoken = store.getters.getIdToken;
            console.log(this.recipients)
            console.log(idtoken)
            await axios.get(
                `${this.baseurl}/forms/query/getbyid/${this.queryId}?api-version=1`,
                {
                    headers: {
                        Authorization: "Bearer " + idtoken,
                    },
                }
            )
                .then((response) => {
                    if (response.data) {
                        this.queries = response.data
                        if (this.queries.queryFor == "FHIR") {
                            this.getfhirdata();
                        }
                        this.messages = response.data.messages
                        this.length = this.messages.length
                        console.log("Length is", this.length)
                        console.log(this.queries)
                        console.log("Messages are", this.messages)
                        this.getMessage()
                        this.lastMessage.push(this.messages.at(-1))
                        console.log("The last message is", this.lastMessage)
                        this.values.value.push(this.queries.createdUserEmail)
                        if (!this.values.value.includes(this.queries.lastModifiedUserEmail)) {
                            this.values.value.push(this.queries.lastModifiedUserEmail)
                        }
                        console.log("Recipients ", this.values.value)
                        this.patientId = this.queries.patientId;
                        if (this.queries.queryOpenStatus == "Closed") {
                            this.removeButtons = true
                            this.showForm = true
                        }
                        console.log(this.messages)
                    }

                    else
                        console.log('Not found')
                })
                .catch((err) => {
                    console.log(err);
                });
        },

        async getfhirdata() {
            await axios
                .get(
                    `${this.baseurl}/fhir-service/fhir/observations?StudyRef=${this.fhirStudyRef}&SiteCode=${this.queries.siteId}&Subjects=${this.queries.subjectId}&VisitCodes=${this.queries.visitId}`,

                ).then((res) => {
                    let fhirdata = res.data;
                    let tempfhirdataarray = [];
                    tempfhirdataarray = fhirdata.filter((eachdata) => {
                        if (!eachdata || !eachdata.resource || !eachdata.resource.code || !eachdata.resource.code.text) {
                            return false;
                        }
                        return eachdata.resource.code.text == this.queries.fieldName;
                    })
                    if (tempfhirdataarray.length > 0 && tempfhirdataarray[0].resource) {
                        this.fhirdataarray = tempfhirdataarray[0].resource;
                    }
                    else {
                        this.fhirdataarray = "";
                    }
                    console.log("this.fhirdataarray", this.fhirdataarray[0].resource);
                })
                .catch((err) => {
                    console.log("Error", err)
                })
        },
        async getMessage() {
            this.messages.filter((item) => {
                item.messagesRecipients.filter((subitem) => {
                    if (subitem.recipients) {
                        this.recipients = []
                        this.recipients = subitem.recipients
                    }
                })
            });

        },
        async jwtDecrypt(token) {
            const base64Url = token.split(".")[1];
            const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
            const jsonPayload = decodeURIComponent(
                atob(base64)
                    .split("")
                    .map(function (c) {
                        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
                    })
                    .join("")
            );
            return JSON.parse(jsonPayload);
        },
        async getUserName() {
            const idToken = store.getters.getIdToken;
            const jwtDecodedValue = await this.jwtDecrypt(idToken);
            this.userName = jwtDecodedValue.name;
            console.log("Username is", this.userName);
        },

        //Reply
        async onReply() {
            if (this.values.value.includes(this.userName)) {
                const filtersList = this.values.value.filter(element => element !== this.userName)
                this.values.value = filtersList
            }
            if (this.values.value.length == 0) {
                alert(this.$t('navigations.please select a recipient'))
            }
            else {
                var confirmed = confirm(this.$t('navigations.are you sure you want to send this message?'))
                if (confirmed == true) {
                    console.log(this.queries.id)
                    console.log(this.postReply)
                    this.raisedBy = this.userName
                    await queryService.apiReply(this.baseurl, this.queries.id, this.postReply, this.raisedBy, this.values.value, this.userName, this.recipients);
                    if (this.closedoption == "showform") {
                        await this.$router.go(-1);
                    }
                    else {
                        await this.$router.push(`/${this.closedoption}`);
                    }
                }
            }
        },

        //Query close 
        async statusChange(removeButtons, showForm) {
            this.showQueryClosurePopup = true;
        },
        async onclosed() {
            var confirmed = confirm(this.$t('navigations.are you sure you want to leave this page?'))
            if (confirmed == true) {
                if (this.closedoption == "showform") {
                    await this.$router.go(-1);
                }

                else {
                    await this.$router.push(`/${this.closedoption}`);
                }

            }
        },
        async openClosurePopup(action, removeButtons, showForm) {
            this.closureAction = action;
            if(action=="reopen") {
                this.showQueryClosurePopup = false;
                this.reopenqueryPopup = true;
                this.reasonselect = false;
            }
            else{
                this.reopenqueryPopup = false;
                this.showQueryClosurePopup = true;
            }
        },
        handleCloseQueryModal() {
            this.selectedReasonId = "";
            this.validationError = false;
            this.showQueryClosurePopup = false;
        },
        handleReopenQueryModal() {
            this.selectedReopenReasonId = "";
            this.validationError = false;
            this.reopenqueryPopup = false;
            this.additionalComments = '';
        },
        async getQueryCloseReasons() {
            const idtoken = store.getters.getIdToken;

            await axios
                .get(`${this.baseurl}/forms/query/getqueryclosereasons`, {
                    headers: {
                        Authorization: "Bearer " + idtoken,
                        "Content-Type": "application/json"
                    }
                })
                .then((res) => {
                    console.log("Close reasons response:", res.data);
                    this.queryCloseReasons = res.data.filter(reason => reason.isActive);
                    console.log("Fetched query close reasons:", this.queryCloseReasons);
                })
                .catch((err) => {
                    console.error("Error fetching query close reasons:", err);
                });
        },
        async getReopenQueryReasons() {
            const idtoken = store.getters.getIdToken;

            await axios
                // .get(`https://localhost:5002/query/reopenreasons`, {
                .get(`${this.baseurl}/forms/query/reopenreasons`, {
                    headers: {
                        Authorization: "Bearer " + idtoken,
                        "Content-Type": "application/json"
                    }
                })
                .then((res) => {
                    console.log("Reopen reasons response:", res.data);
                    this.reopenQueryReasons = res.data;
                    console.log("Fetched query close reasons:", this.reopenQueryReasons);
                })
                .catch((err) => {
                    console.error("Error fetching query reopen reasons:", err);
                });
        },
        async QueryClosure() {
            const selectedReason = this.queryCloseReasons.find(
                reason => reason.id === this.selectedReasonId
            );
            const confirmed = confirm(
                this.$t('navigations.are you sure you want to close this query?')
            );
            if (!confirmed) return;

            try {
                if (this.closureAction === "reply") {
                    // Perform reply logic before closing
                    if (this.values.value.includes(this.userName)) {
                        this.values.value = this.values.value.filter(
                            element => element !== this.userName
                        );
                    }

                    if (this.values.value.length === 0) {
                        alert(this.$t('navigations.please select a recipient'));
                        return;
                    }

                    this.raisedBy = this.userName;
                    await queryService.apiReply(
                        this.baseurl,
                        this.queries.id,
                        this.postReply,
                        this.raisedBy,
                        this.values.value,
                        this.userName,
                        this.recipients
                    );
                }

                // Close the query with reason
                await queryService.apiClose(
                    this.baseurl,
                    this.userName,
                    this.queries.id,
                    selectedReason?.reasonCode || '',
                    selectedReason?.reasonLabel || ''
                );

                this.showQueryClosurePopup = false;
                this.selectedReasonId = '';
                this.closureAction = '';

                // Navigate based on closed option
                if (this.closedoption === "showform") {
                    await this.$router.go(-1);
                } else {
                    await this.$router.push(`/${this.closedoption}`);
                }

            } catch (error) {
                console.error("Error closing query:", error);
            }
        },
        async ReopenClosure() {
            const selectedReason = this.reopenQueryReasons.find(
                reason => reason.id === this.selectedReopenReasonId
            );
            console.log("selectedReopenReasonId",selectedReason)

            try {
                this.reasonselect = false;
                if (this.selectedReopenReasonId === null || this.selectedReopenReasonId === '') {
                    this.reasonselect = true;
                }
                else{
                    const confirmed = confirm(
                        this.$t('navigations.are you sure you want to reopen this query?')
                    );
                    if (!confirmed) return;
                    if (this.closureAction === "reopen") {
                        if (this.values.value.includes(this.userName)) {
                            this.values.value = this.values.value.filter(
                                element => element !== this.userName
                            );
                        }

                        this.raisedBy = this.userName;
                        await queryService.apireopen(
                            this.baseurl,
                            this.queries.id,
                            this.raisedBy,
                            selectedReason.code,
                            selectedReason.label,
                            this.additionalComments
                        );
                    }


                    this.reopenqueryPopup = false;
                    this.selectedReasonId = '';
                    this.closureAction = '';

                    // Navigate based on closed option
                    if (this.closedoption === "showform") {
                        await this.$router.go(-1);
                    } else {
                        await this.$router.push(`/${this.closedoption}`);
                    }
                }   

            } catch (error) {
                console.error("Error reopening query:", error);
            }
        }


    }
}